<template>
  <div class="purchasePlanDetail">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="要货计划详情"
        class="customer-edit"
        width="1200px"
        top="10vh">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="plan"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">采购订单号</td>
            <td style="width: 23%">{{plan.details[0].purchaseOrderNo}}</td>
            <td class="tableLabel">下单时间</td>
            <td style="width: 23%">{{plan.addDate}}</td>
            <td class="tableLabel">创建时间</td>
            <td>{{plan.createdTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">供应商:</td>
            <td>{{plan.gysName}}</td>
            <td class="tableLabel">供应商代码</td>
            <td>{{plan.gysCode}}</td>
            <td class="tableLabel">采购员</td>
            <td>{{plan.buyUserName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">电话</td>
            <td>{{plan.linkManPhone}}</td>
            <td class="tableLabel">传真</td>
            <td>{{plan.linkManFax}}</td>
            <td class="tableLabel">是否加急</td>
            <td style="width: 23%">{{plan.urgent ? "是" : "否"}}</td>
          </tr>
        </table>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="物料信息" name="first">
            <el-table
                :data="plan.details"
                border
                style="width: 100%">
              <el-table-column
                  prop="purchaseOrderNo"
                  align="center"
                  label="采购订单"
                  show-overflow-tooltip
                  width="100"/>
              <el-table-column prop="rowIndex" align="center" label="行号" width="80"/>
              <el-table-column
                  prop="materialNo"
                  align="center"
                  label="物料编号"
                  show-overflow-tooltip
                  width="120"/>
              <el-table-column
                  prop="mappingMaterialNo"
                  align="center"
                  label="旧物料号"
                  show-overflow-tooltip
                  width="120"/>
              <el-table-column
                  prop="materialDesc"
                  align="left"
                  label="物料描述"
                  min-width="120"
                  show-overflow-tooltip/>
              <el-table-column prop="quantity" align="center" label="本次要货数量" width="100"/>
              <el-table-column prop="requireDeliveryDate" align="center" label="需求日期" width="120">
                <template v-slot="scope">
                  <span>{{scope.row.requireDeliveryDate.slice(0, 10)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="deliveryDate"
                  align="center"
                  label="回复交期"
                  width="180">
                <template v-slot="scope">
                  <el-date-picker
                      v-if="scope.row.status !== 30"
                      v-model="scope.row.deliveryDate"
                      :disabled="userType === 1"
                      style="width: 150px"
                      align="center"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      placeholder="选择日期"/>
                  <span v-else>{{scope.row.deliveryDate.slice(0, 10)}}</span>
                </template>
              </el-table-column>
              <!-- 如果状态名是供应商未提交，则可以点击审批或者退回按钮 -->
              <el-table-column
                  v-if="plan.status === 20"
                  label="交期确认"
                  align="center"
                  width="180">
                <template v-slot="scope">
                  <el-radio-group v-model="scope.row.status" :disabled="userType === 2">
                    <el-radio :label="10">退回</el-radio>
                    <el-radio :label="30">确认</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="note" align="center" label="备注" width="120"/>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <template>
          <el-button
              v-if="plan.details[0].status < 2"
              :disabled="userType === 1"
              type="primary"
              :loading="saveLoading"
              @click="handleSave">保存</el-button>
          <el-button
              v-if="plan.status === 20 || plan.details[0].status < 30"
              type="warning"
              :loading="submitLoading"
              @click="handleSubmit">{{plan.status === 20 ? '确认' : '提交'}}</el-button>
        </template>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import LoginUtil from "@/util/loginUtil";

  export default {
    components: {},
    data() {
      return {
        userType: LoginUtil.getUserType(),
        contentLoading: false,
        activeName: "first",
        dialogVisible: false,
        saveLoading: false,
        submitLoading: false,
        plan: {
          details: [],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.plan.pkid = row.pkid;
        this.getData();
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `purchasePlanDetails/${this.plan.pkid}`)
          .then(resp => {
            resp.data.details.forEach(detail => {
              if (detail.deliveryDate === null) {
                detail.deliveryDate = detail.requireDeliveryDate;
              }
            });
            this.plan = resp.data;
            this.contentLoading = false;
          }).catch(() => {
            this.contentLoading = false;
          });
      },
      handleSave() {
        if (this.plan.details[0].requireDeliveryDate === null) {
          return this.$message.error("请选择需求日期");
        } else if (this.plan.details[0].deliveryDate === null) {
          return this.$message.error("请选择送货日期");
        } else if (this.plan.details[0].quantity === null) {
          return this.$message.error("请输入数量");
        } else {
          this.saveLoading = true;
          this.$http
            .put("basic", "purchasePlans/responseDeliveryTime", this.plan)
            .then(() => {
              this.saveLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
            })
            .catch(() => {
              this.saveLoading = false;
            });
        }

      },
      handleSubmit() {
        if (this.plan.details[0].requireDeliveryDate === null) {
          return this.$message.error("请选择需求日期");
        } else if (this.plan.details[0].deliveryDate === null) {
          return this.$message.error("请选择送货日期");
        } else if (this.plan.details[0].quantity === null) {
          return this.$message.error("请输入数量");
        } else {
          this.submitLoading = true;
          this.$http
            .post("basic", "purchasePlans/responseDeliveryTime", this.plan)
            .then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("提交成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.purchasePlanDetail {
  .el-form-item__content {
    margin-left: 2% !important;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
    margin-bottom: 15px;
  }

  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
    border-left: 1px solid #EBEEF5;
  }
}
</style>
